import { coerceSearchExpression, selectedSearchTermsFromExpression } from "./core.js";
import { isPlainObject } from "./shared.js";
import {
  normalizeSelectedSearchTerms,
} from "./terms.js";
export function resolveSearchExpression(expression) {
  return coerceSearchExpression(expression);
}

export function resolveSelectedSearchTerms(value, expression = undefined) {
  if (expression !== undefined) {
    return selectedSearchTermsFromExpression(resolveSearchExpression(expression));
  }
  const selectedTerms = normalizeSelectedSearchTerms(value);
  if (selectedTerms.length || Array.isArray(value)) {
    return selectedTerms;
  }
  return [];
}

export function buildSearchExpressionStatePatch(
  expression,
  searchPatch = null,
) {
  const normalizedExpression = resolveSearchExpression(expression);
  const patch = {
    _map_ui: {
      search: {
        expression: normalizedExpression,
        rawExpression: "",
        rawExpressionTree: null,
        expressionIssues: [],
      },
    },
  };
  if (isPlainObject(searchPatch)) {
    patch._map_ui.search = {
      ...patch._map_ui.search,
      ...searchPatch,
    };
  }
  return patch;
}
